import { render } from "./PraticaVerificaContatore.vue?vue&type=template&id=2c6b3130&scoped=true"
import script from "./PraticaVerificaContatore.vue?vue&type=script&lang=js"
export * from "./PraticaVerificaContatore.vue?vue&type=script&lang=js"

import "./PraticaVerificaContatore.vue?vue&type=style&index=0&id=2c6b3130&scoped=true&lang=css"

import exportComponent from "/Users/andreacotugno/Documents/AGF-Workspace/ask_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c6b3130"]])

export default __exports__